<!-- Sidebar -->
<div
  class="bg-[#111827] text-white transition-all duration-300 ease-in-out flex flex-col h-full relative overflow-visible"
  [ngClass]="collapsed ? 'w-16' : 'w-60'"
  [class.fixed]="isMobile"
  [class.z-50]="isMobile"
  [class.hidden]="isMobile && !sidebarOpen"
>
  <!-- Logo Section -->
  <div class="p-4 border-b border-dashed border-gray-700">
    @if (collapsed) {
    <div class="flex items-center justify-center">
      <div
        class="w-8 h-8 bg-[#6729FF] rounded flex items-center justify-center"
      >
        <span class="text-[#FFFFFF] font-bold text-sm">A</span>
      </div>
    </div>
    } @if (!collapsed) {
    <div class="flex items-center justify-between">
      <div class="flex items-center space-x-3">
        <div
          class="w-8 h-8 bg-[#6729FF] rounded flex items-center justify-center"
        >
          <span class="text-[#FFFFFF] font-bold text-sm">A</span>
        </div>
        <span class="text-xl font-bold text-[#FFFFFF]">AuditHub</span>
      </div>
    </div>
    }
  </div>

  <!-- Navigation Section -->
  <div class="flex-1 overflow-y-auto p-3">
    <!-- Menu Items -->
    <nav class="space-y-2">
      @for (item of menuItems(); track item.label) {
      <div class="relative">
        <!-- Menu items with submenus -->
        @if (item.hasSubmenu && item.submenus) {
        <button
          (click)="toggleSubmenu(item.label)"
          (mouseenter)="onMenuHover(item.label, $event)"
          (mouseleave)="onMenuLeave()"
          class="w-full flex items-center px-2 py-1.5 text-sm rounded-lg transition-colors"
          [ngClass]="
            collapsed
              ? item.active
                ? 'justify-center bg-[#F3EFFF] '
                : 'justify-center hover:bg-gray-700'
              : item.active
              ? 'space-x-3 bg-[#F3EFFF]'
              : 'space-x-3 hover:bg-gray-700'
          "
        >
          <svg
            class="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            [ngClass]="item.active ? 'text-[#6729FF]' : ''"
          >
            @if (item.svgPaths) { @for (path of item.svgPaths; track path) {
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              [attr.d]="path"
            />
            } } @if (item.svgPath && !item.svgPaths) {
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              [attr.d]="item.svgPath"
            />
            }
          </svg>
          @if (!collapsed) {
          <span
            class="flex-1 text-left font-medium"
            [ngClass]="
              item.active
                ? 'text-[#6729FF] font-medium'
                : 'text-[#FFFFFF] font-medium'
            "
            >{{ item.label }}</span
          >
          } @if (!collapsed) {
          <svg
            class="w-4 h-4 transition-transform"
            [ngClass]="item.active ? 'text-[#6729FF]' : 'text-[#FFFFFF]'"
            [class.rotate-0]="isSubmenuExpanded(item.label)"
            [class.-rotate-90]="!isSubmenuExpanded(item.label)"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
          }
        </button>
        <!-- Submenu items -->
        @if (!collapsed && isSubmenuExpanded(item.label)) {
        <div class="ml-1 mt-1 space-y-0.5">
          @for (submenu of item.submenus; track submenu.label) {
          <a
            [routerLink]="submenu.route"
            (click)="onNavigationClick(); activeMenuTitle.emit(submenu.label)"
            class="flex items-center px-3 py-1.5 text-sm rounded-md transition-colors"
            [ngClass]="
              submenu.active
                ? 'text-[#b69bfc]'
                : 'text-[#ffffff] hover:text-gray-300 hover:bg-gray-700/50'
            "
          >
            <span
              class="w-1.5 h-1.5 rounded-full mr-2.5"
              [ngClass]="submenu.active ? 'bg-[#b69bfc]' : 'bg-[#ffffff]'"
            ></span>
            <span class="font-medium">{{ submenu.label }}</span>
          </a>
          }
        </div>
        }
        <!-- Hover popover for collapsed sidebar (desktop only) -->
        @if (collapsed && !isMobile && isMenuHovered(item.label) &&
        item.submenus) {
        <!-- Invisible bridge area to make mouse movement easier -->
        <div
          class="fixed z-[99]"
          [style.left.px]="getPopoverLeft() - 8"
          [style.top.px]="getPopoverTop(item.label)"
          [style.width.px]="4"
          [style.height.px]="40"
          (mouseenter)="onPopoverEnter()"
          (mouseleave)="onMenuLeave()"
        ></div>
        <div
          class="fixed z-[100] ml-4 bg-white border border-gray-200 rounded-lg shadow-xl overflow-hidden min-w-[200px] max-w-[220px]"
          [style.left.px]="getPopoverLeft()"
          [style.top.px]="getPopoverTop(item.label)"
          (mouseenter)="onPopoverEnter()"
          (mouseleave)="onPopoverLeave()"
        >
          <!-- Header -->
          <div class="px-4 py-2 border-b border-gray-200 bg-gray-50/50">
            <span class="text-[13px] font-semibold text-gray-800">{{
              item.label
            }}</span>
          </div>
          <!-- Submenu Items -->
          <div class="flex flex-col gap-1.5 py-1.5">
            @for (submenu of item.submenus; track submenu.label) {
            <a
              [routerLink]="submenu.route"
              (click)="
                onNavigationClick();
                activeMenuTitle.emit(submenu.label);
                onPopoverLeave()
              "
              class="flex items-center px-4 py-2 text-xs transition-all duration-150 group"
              [ngClass]="
                submenu.active
                  ? 'text-[#6729FF] bg-[#F3EFFF]'
                  : 'text-gray-700 hover:text-[#6729FF] hover:bg-[#F3EFFF]/50'
              "
            >
              <span
                class="w-1.5 h-1.5 rounded-full mr-3 transition-all duration-150"
                [ngClass]="
                  submenu.active
                    ? 'bg-[#6729FF]'
                    : 'bg-gray-400 group-hover:bg-[#6729FF]'
                "
              ></span>
              <span class="font-medium">{{ submenu.label }}</span>
            </a>
            }
          </div>
        </div>
        } }
        <!-- Regular menu items -->
        @if (!item.hasSubmenu) {
        <div class="relative">
          <a
            [routerLink]="item.route"
            (click)="onNavigationClick(); expandedMenu = null"
            (mouseenter)="onRegularMenuHover(item.label, $event)"
            (mouseleave)="onRegularMenuLeave()"
            class="flex items-center py-1.5 text-sm rounded-lg transition-colors"
            [ngClass]="
              collapsed
                ? item.active
                  ? 'justify-center bg-[#F3EFFF] px-0'
                  : 'justify-center hover:bg-gray-700 px-0'
                : item.active
                ? 'space-x-3 bg-[#F3EFFF] px-2'
                : 'space-x-3 hover:bg-gray-700 px-2'
            "
          >
            <svg
              class="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              [ngClass]="item.active ? 'text-[#6729FF]' : ''"
            >
              @if (item.svgPaths) { @for (path of item.svgPaths; track path) {
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                [attr.d]="path"
              />
              } } @if (item.svgPath && !item.svgPaths) {
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                [attr.d]="item.svgPath"
              />
              }
            </svg>
            @if (!collapsed) {
            <span
              class="font-medium"
              [ngClass]="
                item.active
                  ? 'text-[#6729FF] font-medium'
                  : 'text-[#FFFFFF] font-medium'
              "
              >{{ item.label }}</span
            >
            }
          </a>
          <!-- Custom tooltip for collapsed sidebar (desktop only) -->
          @if (collapsed && !isMobile && isRegularMenuHovered(item.label)) {
          <div
            class="fixed z-[100] pointer-events-none transition-opacity duration-200 ease-out"
            [style.left.px]="getTooltipLeft()"
            [style.top.px]="getTooltipTop(item.label)"
            [style.transform]="'translateY(-50%)'"
          >
            <div
              class="bg-white text-gray-700 text-xs font-semibold px-3 py-2 rounded-md whitespace-nowrap [box-shadow:0_25px_50px_-12px_rgba(0,0,0,0.25),0_0_0_1px_rgba(0,0,0,0.05)]"
            >
              {{ item.label }}
              <!-- Tooltip arrow -->
              <div
                class="absolute left-0 top-1/2 -translate-x-full -translate-y-1/2"
              >
                <div
                  class="w-0 h-0 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-r-[6px] border-r-white [filter:drop-shadow(-5px_0_10px_rgba(0,0,0,0.35))]"
                ></div>
              </div>
            </div>
          </div>
          }
        </div>
        }
      </div>
      }
    </nav>
  </div>
</div>

<!-- Mobile Overlay -->
@if (isMobile && sidebarOpen) {
<div
  class="fixed inset-0 bg-black bg-opacity-50 z-40"
  (click)="onMobileSidebarClose()"
></div>
}
